import { render, staticRenderFns } from "./UserNocite.vue?vue&type=template&id=6aea0f7e&scoped=true"
import script from "./UserNocite.vue?vue&type=script&lang=js"
export * from "./UserNocite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea0f7e",
  null
  
)

export default component.exports